export enum DragAndDropActions {
    SET_IN_DROPZONE = 'SET_IN_DROPZONE',
    RESET_DROPZONE = 'RESET_DROP_ZONE',
    SET_DROP_DEPTH = 'SET_DROP_DEPTH'
}

export const initialDragAndDropState = { inDropZone: false, fileList: [], dropDepth: 0 }

const DragAndDropReducer = (state, action) => {
    switch (action.type) {
        case DragAndDropActions.SET_DROP_DEPTH:
            return {...state, dropDepth: action.dropDepth}
        case DragAndDropActions.SET_IN_DROPZONE:
            return { ...state, inDropZone: action.inDropZone };
        case DragAndDropActions.RESET_DROPZONE:
            return { ...state, inDropZone: false, dropDepth: 0 };
        default:
            return state;
    }
}

export default DragAndDropReducer;